import { useMemo } from 'react';
export const useSelectedItemLabel = (elements, activeItem, filterString) => {
  const selectedItemLabel = useMemo(() => {
    if (filterString || filterString === '') {
      return filterString;
    }
    return elements.find(element => element.id?.toString() === activeItem?.toString())?.label ?? '';
  }, [activeItem, filterString, elements]);
  return {
    selectedItemLabel
  };
};